import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckIcon, GiftIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['PDF principal con más de 140 ejercicios analizados.', 'Checklists rápidas para consultarlo todo en segundos.', 'Ilustraciones claras para entender cada movimiento.', 'Un recurso de consulta permanente, listo para usar.', 'Base sólida para justificar cada decisión profesional.'];
  const bonuses = [{
    title: 'Bono 1: Bases Nutricionales del Desarrollo Muscular',
    desc: 'Guía práctica para acompañar el entrenamiento de fuerza con alimentación, hipertrofia y recuperación.',
    image: 'https://cdn.magicpatterns.com/uploads/gMNTmNetU77i5R22iGxBUU/mock_uo_bono_1.png'
  }, {
    title: 'Bono 2: La Práctica Profesional del Entrenador Personal',
    desc: 'Guía de organización y planificación profesional para trabajar con más criterio y orden.',
    image: 'https://cdn.magicpatterns.com/uploads/aGqRXv4vYyyrUHTK14Eqtm/mock_upp_bono_2.png'
  }];
  return <section className="py-10 bg-background-dark border-y border-card-border-dark" data-id="element-15">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-16">
        <FadeIn className="text-center mb-10" data-id="element-17">
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-white" data-id="element-18">
            Lo Que Vas a Recibir Hoy
          </h2>
          <p className="text-xl text-gray-400" data-id="element-19">
            Todo el arsenal técnico que necesitas en un solo lugar.
          </p>
        </FadeIn>

        <div className="grid lg:grid-cols-2 gap-8 items-start" data-id="element-20">
          {/* Main Deliverables */}
          <FadeIn delay={0.2} data-id="element-21">
            <div className="bg-card-dark border border-card-border-dark rounded-3xl p-6 md:p-8 shadow-xl" data-id="element-22">
              <h3 className="text-2xl font-bold mb-6 flex items-center gap-3 text-white" data-id="element-23">
                <span className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm" data-id="element-24">
                  1
                </span>
                El Pack Principal
              </h3>
              <ul className="space-y-4" data-id="element-25">
                {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-4" data-id="element-26">
                    <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center shrink-0 mt-1" data-id="element-27">
                      <CheckIcon className="w-4 h-4 text-green-500" data-id="element-28" />
                    </div>
                    <span className="text-lg text-gray-300 leading-relaxed" data-id="element-29">
                      {benefit}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Bonuses */}
          <FadeIn delay={0.4} data-id="element-30">
            <div className="space-y-6" data-id="element-31">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary/10 text-secondary border border-secondary/20 font-bold text-sm uppercase tracking-wider mb-2" data-id="element-32">
                <GiftIcon className="w-4 h-4" data-id="element-33" />
                Bonos Exclusivos Incluidos
              </div>

              {bonuses.map((bonus, index) => <div key={index} className="bg-gradient-to-br from-card-dark to-background-dark border border-secondary/30 rounded-3xl p-6 sm:p-8 shadow-lg relative overflow-hidden group hover:border-secondary/60 transition-colors flex flex-col sm:flex-row items-center gap-6" data-id="element-34">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-secondary/5 rounded-full blur-2xl group-hover:bg-secondary/10 transition-colors" data-id="element-35" />

                  <div className="w-56 sm:w-64 shrink-0 relative z-10" data-id="element-36">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-auto drop-shadow-xl group-hover:scale-105 transition-transform duration-300" data-id="element-37" />
                  </div>

                  <div className="relative z-10 text-center sm:text-left" data-id="element-38">
                    <h4 className="text-xl font-bold text-white mb-3" data-id="element-39">
                      {bonus.title}
                    </h4>
                    <p className="text-gray-400 mb-3" data-id="element-40">{bonus.desc}</p>
                    <span className="inline-block font-black text-lg text-green-400 uppercase tracking-wide" data-id="element-41">
                      🎁 Hoy GRATIS
                    </span>
                  </div>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}